import { render, staticRenderFns } from "./NewStaff.vue?vue&type=template&id=69873bec&lang=pug&"
import script from "./NewStaff.vue?vue&type=script&lang=js&"
export * from "./NewStaff.vue?vue&type=script&lang=js&"
import style0 from "./NewStaff.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports